import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState, useEffect } from 'react';
import { PopupHeader, CloseModalLink, Container, ValidateCodeActionButton, ValidateCodeDescription, ValidateCodeLink, ContentContainer, DisplayEmail, ErrorBanner, MFALink, FooterBanner } from '../styles';
import { texts } from '../../config/texts';
import { PasswordInput } from '../passwordInput/PasswordInput';
import ValidateCodeIcon from '../../icons/ValidateCodeIcon';
import { clickstreamViewEvent, interactionRioEvent } from '../../lib/rio';
import { Step } from '../webMfa/WebMfa.types';
import { NotificationTypes } from '@chegg-ui/notification-banner';
var ValidateCode = function ValidateCode(props) {
  var validateCodeText = texts.validateCodeText,
    errorMessages = texts.errorMessages;
  var email = props.email,
    isLoading = props.isLoading,
    clearError = props.clearError,
    onModalClose = props.onModalClose,
    validateCode = props.validateCode,
    errorMessage = props.errorMessage,
    returnToSendEmailStep = props.returnToSendEmailStep;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    code = _useState2[0],
    setCode = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    disableButton = _useState4[0],
    setButtonDisableState = _useState4[1];
  useEffect(function () {
    clickstreamViewEvent(Step.ValidateCode);
  }, []);
  var onInputChange = function onInputChange(val) {
    clearError();
    setCode(val);
    setButtonDisableState(val.length != 6 || !val.match(/^[0-9]*$/));
  };
  var cleanComponentAndReturn = useCallback(function () {
    setCode('');
    returnToSendEmailStep();
  }, [returnToSendEmailStep]);
  var onSubmit = useCallback(function (e) {
    e.preventDefault();
    interactionRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'button',
          name: 'submitted mfa code',
          region_name: 'mfa validate code modal',
          text: texts.validateCodeText.buttonText
        }
      }
    });
    clearError();
    setCode('');
    setButtonDisableState(true);
    validateCode(code);
  }, [clearError, code, validateCode]);
  var closeModal = useCallback(function () {
    onModalClose();
  }, [onModalClose]);
  var renderNewCodeLink = function renderNewCodeLink(error) {
    if (error === errorMessages.expired_token) {
      return /*#__PURE__*/React.createElement(CloseModalLink, {
        "data-test": "mfa_return_to_signin_link",
        onClick: cleanComponentAndReturn
      }, errorMessages.request_new_token);
    }
  };
  var onContactUsClick = function onContactUsClick() {
    interactionRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'link',
          name: 'reach out for help',
          region_name: 'mfa send code modal faq link',
          text: validateCodeText.footerCheckFAQ
        }
      }
    });
  };
  var onNewCodeClick = function onNewCodeClick() {
    interactionRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'link',
          name: 'request new code',
          region_name: 'mfa request new code in validate code modal',
          text: validateCodeText.requestCodeLink
        }
      }
    });
    cleanComponentAndReturn();
  };
  var renderBannerMessage = function renderBannerMessage() {
    return /*#__PURE__*/React.createElement("div", null, errorMessage, /*#__PURE__*/React.createElement(ValidateCodeLink, {
      "data-test": "try_again_link",
      onClick: cleanComponentAndReturn
    }, errorMessages.try_again_text), errorMessages.later_text);
  };
  var renderErrorMessage = function renderErrorMessage() {
    if (errorMessage === errorMessages.too_many_requests) {
      return /*#__PURE__*/React.createElement(ErrorBanner, {
        "data-test": "validate_code_error",
        id: "validate_code_error",
        type: NotificationTypes.Error,
        message: renderBannerMessage(),
        bannerStyle: 'inline',
        title: ''
      });
    }
  };
  return /*#__PURE__*/React.createElement("form", {
    id: 'validateCodeDialog',
    "data-test": "validate-code-dialog",
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ValidateCodeIcon, null), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(PopupHeader, {
    "data-test": "validation_code_header"
  }, validateCodeText.header), /*#__PURE__*/React.createElement(ValidateCodeDescription, null, validateCodeText.description), /*#__PURE__*/React.createElement(DisplayEmail, {
    "data-test": 'display_email'
  }, email), /*#__PURE__*/React.createElement(PasswordInput, {
    inputId: "password_input",
    "data-test": 'validation_input',
    "aria-label": 'validationCodeHeader',
    labelText: '',
    value: code,
    onChange: onInputChange,
    className: 'validateCodeInput',
    hideButton: true,
    placeholder: validateCodeText.codePlaceholder,
    errorText: errorMessage && errorMessage !== errorMessages.too_many_requests ? errorMessage : undefined,
    fullHeight: true
  }), /*#__PURE__*/React.createElement(ValidateCodeDescription, null, validateCodeText.secondDecription, ' ', /*#__PURE__*/React.createElement(MFALink, {
    "data-test": "validate_code_link",
    onClick: onNewCodeClick
  }, validateCodeText.requestCodeLink), ".")), renderErrorMessage(), /*#__PURE__*/React.createElement(ValidateCodeActionButton, {
    type: "submit",
    size: "large",
    disabled: disableButton,
    "data-test": "validate_code_button",
    isLoading: isLoading
  }, validateCodeText.buttonText), /*#__PURE__*/React.createElement(FooterBanner, {
    "data-test": "send_email_footer_banner",
    id: "sendEmailFooterContent",
    type: NotificationTypes.Information,
    message: validateCodeText.footerWrongAddress,
    bannerStyle: "inline",
    ctaLink: /*#__PURE__*/React.createElement(MFALink, {
      "data-test": "contact_us_link",
      target: "_blank",
      href: 'https://www.chegg.com/contactus?a=How-does-multi-factor-authentication-work---id--HhfxSshaSpKIqQW-Er4qfA',
      onClick: onContactUsClick
    }, validateCodeText.footerCheckFAQ),
    title: "",
    fluid: true
  })));
};
export default ValidateCode;